import "@/App.css";

const Home = () => {
  return (
    <div className="page-container" data-testid="home-page">
      {/* Noise texture overlay */}
      <div className="noise-overlay" aria-hidden="true"></div>
      
      {/* Subtle radial gradient */}
      <div className="background-gradient" aria-hidden="true"></div>
      
      {/* Main content */}
      <main className="content-wrapper">
        <h1 className="name animate-fade-in" data-testid="designer-name">
          JOSCHA RADAJ
        </h1>
        
        <p className="subtitle animate-fade-in-delay-1" data-testid="subtitle">
          Designer
        </p>
        
        <p className="description animate-fade-in-delay-2" data-testid="description">
          Neue Seite ist in Arbeit
        </p>
        
        <a 
          href="mailto:mail@joscharadaj.de" 
          className="email-link animate-fade-in-delay-3"
          data-testid="email-link"
        >
          mail@joscharadaj.de
        </a>
      </main>
    </div>
  );
};

function App() {
  return <Home />;
}

export default App;
